import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { freePropertyTitleColors, machineCardTheme } from "../../Colors/colors";
import UserContext from "../../themeContext/UserContext";
import { MachinesByGroup } from "../../Types/dashboardTypes";
import MyBarChart from "../BarChart/barChart";
import CustomDonutChart from "../DonutChart/myDonutChart";
import MachineSelector from "./MachineSelector";
import AvgOee from "./avgOee";
import Properties from "./propertiesText";
import { BorderOutlined } from "@ant-design/icons";
import ShowAllMachineIcon from "../../Icons/ShowAllMachinesIcon";
import { Button } from "antd";

import "./MachineCard.less";
import AllDonutCharts from "../DonutChart/AllDonutCharts";
import MachineDataContext from "../../themeContext/MachineDataContext";
import { HistoricalTsiDataType } from "../../Types/portalTypes";

interface Props {
  machinesByGroup: MachinesByGroup[];
  currentMachineIndex: number;
  setCurrentMachineIndex: React.Dispatch<React.SetStateAction<number>>;
  groupHistoricalData: HistoricalTsiDataType;
}

const MachineCard: React.FC<Props> = (props) => {
  const { machinesByGroup, currentMachineIndex, setCurrentMachineIndex, groupHistoricalData } = props;
  const [isShowAllMachines, setIsShowAllMachines] = useState(false);
  const { userInfo } = useContext(UserContext);
  const accountType = userInfo.accountType;

  return (
    <>
      {accountType == "free" ? <FreeRender machinesByGroup={machinesByGroup} /> : <></>}
      {accountType == "standard" ? (
        <StandardRender
          machinesByGroup={machinesByGroup}
          currentMachineIndex={currentMachineIndex}
          setCurrentMachineIndex={setCurrentMachineIndex}
          isShowAllMachines={isShowAllMachines}
          setIsShowAllMachines={setIsShowAllMachines}
          groupHistoricalData={groupHistoricalData}
        />
      ) : (
        <></>
      )}
      {accountType == "premium" ? (
        <PremiumRender
          machinesByGroup={machinesByGroup}
          currentMachineIndex={currentMachineIndex}
          setCurrentMachineIndex={setCurrentMachineIndex}
          isShowAllMachines={isShowAllMachines}
          setIsShowAllMachines={setIsShowAllMachines}
          groupHistoricalData={groupHistoricalData}
        />
      ) : (
        <></>
      )}
    </>
  );
};
export default MachineCard;

interface FreeRenderMachinesProps {
  machinesByGroup: MachinesByGroup[];
}
const FreeRender: React.FC<FreeRenderMachinesProps> = (props) => {
  const { machinesByGroup } = props;
  const machines = machinesByGroup.length > 3 ? machinesByGroup.slice(0, 3) : machinesByGroup;
  const data = useContext(MachineDataContext);
  const jsxCharts: JSX.Element[] = [];
  // let newObject = {
  //   oeeTimeDown: null,
  //   oeeUnitsBad: null,
  //   oeeUnitsGood: null,
  //   oeeUnitsTotal: null,
  //   oeeTimeIdealCycle: null,
  //   oeeTimeOperating: null,
  // } as DataObject;
  machines.forEach((value, index) => {
    if (value != undefined) {
      jsxCharts.push(
        <div key={index}>
          <div style={{ color: freePropertyTitleColors[index] }} className="properties-title free">
            {value.machineName}
          </div>
          <div className="free-properties">
            <Properties isShowTitle={false} selectedMachine={value} visibleData={data[value.machineSerial]} />
          </div>
        </div>
      );
    }
  });
  return (
    <div>
      <div className={"machine-card"}>
        <div>
          <div className="machine-properties-text">Machine Properties</div>
          <div className="flex space-between margin-sides-100">{jsxCharts}</div>
        </div>
      </div>
    </div>
  );
};

interface StandardRenderMachinesProps {
  isShowAllMachines: boolean;
  setIsShowAllMachines: React.Dispatch<React.SetStateAction<boolean>>;
  groupHistoricalData: HistoricalTsiDataType;
}
const StandardRender: React.FC<Props & StandardRenderMachinesProps> = (props) => {
  const {
    machinesByGroup,
    currentMachineIndex,
    setCurrentMachineIndex,
    isShowAllMachines,
    setIsShowAllMachines,
    groupHistoricalData,
  } = props;
  const navigate = useNavigate();
  const selectedMachine = machinesByGroup[currentMachineIndex];

  return (
    <div style={{ marginBottom: "10px" }}>
      <div className={"machine-card"}>
        <div className="flex machine-card-header">
          <Button className="primary-button" onClick={() => navigate("/dashboard/new-machine")}>
            New Machine
          </Button>
          {isShowAllMachines ? (
            <div className="all-machines-text">All Machines</div>
          ) : (
            <MachineSelector
              machinesByGroup={machinesByGroup}
              currentMachineIndex={currentMachineIndex}
              setCurrentMachineIndex={setCurrentMachineIndex}
            />
          )}
          <div className="flex machine-content-buttons">
            <button
              onClick={() => setIsShowAllMachines(false)}
              className={"orange-circle-button single " + isShowAllMachines}
            >
              <BorderOutlined style={{ fontSize: "24px" }} />
            </button>
            <button
              onClick={() => setIsShowAllMachines(true)}
              className={"orange-circle-button all " + isShowAllMachines}
            >
              <ShowAllMachineIcon color={isShowAllMachines ? "#000" : "var(--gray-1)"} />
            </button>
          </div>
        </div>
        {isShowAllMachines ? (
          <div className="children-donut-charts-main-div">
            <AllDonutCharts isShowAllMachines={isShowAllMachines} machinesByGroup={machinesByGroup} />
          </div>
        ) : (
          <div className="flex margin-sides-50 space-between align-items-center">
            <Properties selectedMachine={selectedMachine} />
            <CustomDonutChart
              diameter={230}
              color={machineCardTheme[currentMachineIndex][1]}
              selectedMachine={selectedMachine}
              className="machine-card-single-donut"
            />
            <AvgOee
              machinesByGroup={machinesByGroup}
              currentMachineIndex={currentMachineIndex}
              groupHistoricalData={groupHistoricalData}
              color={machineCardTheme[currentMachineIndex][1]}
            />
          </div>
        )}
      </div>
    </div>
  );
};

const PremiumRender: React.FC<Props & StandardRenderMachinesProps> = (props) => {
  const {
    machinesByGroup,
    currentMachineIndex,
    setCurrentMachineIndex,
    isShowAllMachines,
    setIsShowAllMachines,
    groupHistoricalData,
  } = props;
  const navigate = useNavigate();
  const selectedMachine = machinesByGroup[currentMachineIndex];

  return (
    <div style={{ marginBottom: "10px" }}>
      <div className={"machine-card"}>
        <div className="flex machine-card-header">
          <Button className="primary-button" onClick={() => navigate("/dashboard/new-machine")}>
            New Machine
          </Button>
          {isShowAllMachines ? (
            <div className="all-machines-text">All Machines</div>
          ) : (
            <MachineSelector
              machinesByGroup={machinesByGroup}
              currentMachineIndex={currentMachineIndex}
              setCurrentMachineIndex={setCurrentMachineIndex}
            />
          )}
          <div className="flex machine-content-buttons">
            <button
              onClick={() => setIsShowAllMachines(false)}
              className={"orange-circle-button single " + isShowAllMachines}
            >
              <BorderOutlined style={{ fontSize: "24px" }} />
            </button>
            <button
              onClick={() => setIsShowAllMachines(true)}
              className={"orange-circle-button all " + isShowAllMachines}
            >
              <ShowAllMachineIcon color={isShowAllMachines ? "#000" : "var(--gray-1)"} />
            </button>
          </div>
        </div>
        {isShowAllMachines ? (
          <div className="children-donut-charts-main-div">
            <AllDonutCharts isShowAllMachines={isShowAllMachines} machinesByGroup={machinesByGroup} />
          </div>
        ) : (
          <div className="flex space-between margin-sides-50">
            <MyBarChart selectedMachine={selectedMachine} colorTheme={machineCardTheme[currentMachineIndex]} />
            <CustomDonutChart
              diameter={230}
              color={machineCardTheme[currentMachineIndex] && machineCardTheme[currentMachineIndex][1]}
              selectedMachine={selectedMachine}
              className="machine-card-single-donut"
            />
            <div>
              <Properties selectedMachine={selectedMachine} />
              <AvgOee
                machinesByGroup={machinesByGroup}
                currentMachineIndex={currentMachineIndex}
                groupHistoricalData={groupHistoricalData}
                color={machineCardTheme[currentMachineIndex] && machineCardTheme[currentMachineIndex][1]}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
